import React, { useEffect } from 'react';

export default function Lightbox({ images = [], currentIndex = 0, onClose, onPrev, onNext }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden'; // Forhindr scroll af baggrunden
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [onClose, onPrev, onNext]);

  if (!images.length) return null;

  const currentImage = images[currentIndex];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm transition-opacity duration-300">
      {/* Luk-knap */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 hover:scale-105 transition-all duration-300 cursor-pointer"
        aria-label="Luk"
      >
        <i className="fa-solid fa-xmark text-xl"></i>
      </button>

      {/* Forrige-knap */}
      {images.length > 1 && (
        <button
          onClick={onPrev}
          className="absolute left-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 hover:scale-105 transition-all duration-300 cursor-pointer"
          aria-label="Forrige"
        >
          <i className="fa-solid fa-chevron-left text-lg"></i>
        </button>
      )}

      {/* Næste-knap */}
      {images.length > 1 && (
        <button
          onClick={onNext}
          className="absolute right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 hover:scale-105 transition-all duration-300 cursor-pointer"
          aria-label="Næste"
        >
          <i className="fa-solid fa-chevron-right text-lg"></i>
        </button>
      )}

      {/* Billede container */}
      <div className="relative max-h-[85vh] max-w-[90vw] flex flex-col items-center justify-center">
        <img
          src={currentImage}
          alt={`Billede ${currentIndex + 1}`}
          className="max-h-[80vh] max-w-[90vw] object-contain rounded-lg shadow-2xl select-none"
        />
        
        {/* Billedtæller */}
        <div className="mt-4 text-sm font-medium text-white/60">
          {currentIndex + 1} / {images.length}
        </div>
      </div>
    </div>
  );
}
